import { Component, OnInit, Inject } from '@angular/core';
import { UploadFileModel } from './upload-file.model';
import { FilesService } from './files.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FilesListComponent } from './files-list.component';
import { Utils } from '../../shared/utils';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.css'],
    standalone: false
})
export class UploadFileComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<FilesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private fileService: FilesService,
  ) { }

  public files: any = [];
  public number = 0;
  public errores = 0;
  public error = false;
  public uploading = false;
  public path: string = this.data.path;
  public message = '';
  public messages = [];

  ngOnInit() {
    if (this.data.droppedFiles) {
      this.uploadFile(this.data.droppedFiles);
    }
  }

  public deleteAttachment(index) {
    this.files.splice(index, 1);
  }

  public uploadFile(event) {
    this.errores = 0;
    this.number = event.length;
    this.messages = [];

    if (this.number > 0 && this.number <= 10) {

      for (let index = 0; index < event.length; index++) {
        this.error = false;
        const element = event[index];

        this.files.push(element.name);

        const fileToUpload: UploadFileModel = new UploadFileModel();
        fileToUpload.name = element.name;
        fileToUpload.lastModified = element.lastModified;
        fileToUpload.lastModifiedDate = element.lastModifiedDate;
        fileToUpload.size = element.size;
        fileToUpload.type = element.type;
        fileToUpload.webkitRelativePath = element.webkitRelativePath;

        let type = '';
        const temp = fileToUpload.name.split('.');
        const name = fileToUpload.name.substr(0, fileToUpload.name.lastIndexOf('.'))


        const afterDot = fileToUpload.name.substr(fileToUpload.name.lastIndexOf('.'));
        if (afterDot.includes('png') || afterDot.includes('PNG') ||
          afterDot.includes('jpg') || afterDot.includes('JPG') ||
          afterDot.includes('jpeg') || afterDot.includes('JPEG')) {
          type = 'Image';
        } else if (afterDot.includes('pdf') || afterDot.includes('PDF')) {
          type = 'PDF';
        } else if (afterDot.includes('docx') || afterDot.includes('DOCX')) {
          type = 'Word';
        } else if (afterDot.includes('xlsx') || afterDot.includes('XLSX')) {
          type = 'Excel';
        } else {
          this.error = true;
          this.errores += 1;
          this.messages.push(name + ': Debe ser una imagen (png, jpg), pdf, docx o xlsx, por favor, vuelva a seleccionar.');
          this.files.shift();
        }

        if (!this.error) {
          if (this.data.storageSpent + Utils.FromByteToGb(fileToUpload.size) < this.data.storageCapacity) {
            const self = this;

            if (type === 'Image') {
              const img = new Image();
              img.src = window.URL.createObjectURL(element);

              img.onload = function () {
                window.URL.revokeObjectURL(img.src);
                if (img.naturalWidth > 200 && img.naturalHeight > 200) {
                  self.uploading = true;
                  self.fileService.createFile(element, type, name, self.path).then(responseMessage => {
                    self.messages.push(name + ': ' + responseMessage);
                    self.files.shift();
                    self.uploading = false;
                  });
                } else {
                  self.errores += 1;
                  self.messages.push(name + ': La imagen debe ser superior a 200px');
                  self.files.shift();
                }
              };
            } else {
              self.uploading = true;
              self.fileService.createFile(element, type, name, self.path)
                .then(responseMessage => {
                  // self.messages.push(name + ': Guardado correctamente');
                  self.messages.push(name + ': ' + responseMessage);
                  self.files.shift();
                  self.uploading = false;
                });
            }
          } else {
            this.error = true;
            this.errores += 1;
            this.messages.push(name + ': Ya ha superado su capacidad de almacenamiento');
            this.files.shift();
          }
        }
      }
    } else {
      this.displayInfo("Debe seleccionar mínimo 1 fichero, y máximo 10.");
    }
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }


  public trackByIndex(i: number) { return i; }

}
